<template>
	<b-row>
		<b-col md v-if="viewModel.id > 0">
			<small>
				<strong>{{ this.$t('bookings.reservationCreatedBy') + ': ' }}</strong>
				<span v-if="viewModel.creationUser">{{ viewModel.creationUser.firstName }} | {{ reservationDatetimeStr }}</span>
				<template v-if="viewModel.cancelUser">
					<br />
					<strong>{{ this.$t('bookings.canceledBy') + ': ' }}</strong>
					{{ viewModel.cancelUser.firstName }} |
					<strong>{{ this.$t('bookings.cancelationDate') }}</strong>
					{{ reservationCancelDatetimeStr }}
				</template>
			</small>
		</b-col>
	</b-row>
</template>

<script>
import moment from "moment";
import { mapActions, mapState,mapMutations } from "vuex";
export default {
	props: {
		modelId: Number,
		copyFromId: Number,
	},
	computed: {
		...mapState("reservation", ["viewModel","quote"]),
		reservationDatetimeStr() {
			return moment(this.viewModel.reservationDatetime).format(
				"DD/MMMM/YYYY HH:mm"
			);
		},
		reservationCancelDatetimeStr() {
			return moment(this.viewModel.cancelDatetime).format(
				"DD/MMMM/YYYY HH:mm"
			);
		}
	},
	methods: {
		...mapActions("reservation", ["_fetchModel", "_fetchNotes"]),
		...mapMutations("reservation",["SET_UPDATE_QUOTE_PROPS"]),
		openFormQuote(){
			this.SET_UPDATE_QUOTE_PROPS({showForm:true})
		}
	}
};
</script>

<style></style>
